module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 3.1dd61784.png";